import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import Loader from 'components/commons/_/loader/Loader';

import { MissionTile } from './tile/MissionTile';
import { useQuery } from 'react-query';
import { CalendarActionTile } from './tile/CalendarActionTile';

const tabToActionStatus = {
	active: 'released',
	done: 'closed',
};

function MissionList({ tab, taskService, calendarService }) {
	const i18nKey = 'mission-list';

	const taskListQuery = useQuery({
		queryKey: ['mission-list', tab],
		queryFn: () => taskService.fetchList({ state: tab, place: 'task_page_list' }).then(list => ({ list })),
		cacheTime: 0,
	});
	const actionListQuery = useQuery({
		queryKey: ['calendar-action-list', tab],
		queryFn: () => calendarService.fetchActionList(tabToActionStatus[tab]),
		cacheTime: 0,
		enabled: tab !== 'archived',
	});
	const isLoading = taskListQuery.isLoading || actionListQuery.isLoading;

	return (
		<Fragment>
			<hr className="mb-4 mb-sm-5" />
			<div className="fs-4">
				{isLoading ? (
					<Loader />
				) : taskListQuery.error ? (
					<p className="fs-6 mx-0 mx-sm-3">
						<FormattedMessage id={`${i18nKey}.error.${taskListQuery.error}`} />
					</p>
				) : isEmpty(taskListQuery.data.list) && isEmpty(actionListQuery.data?.items) ? (
					<p className="fs-6 mx-0 mx-sm-3">
						<FormattedMessage id={`${i18nKey}.error.empty`} />
					</p>
				) : (
					<div className="row">
						{tab !== 'archived' &&
							actionListQuery.data?.items.map(action => (
								<CalendarActionTile key={action.id} action={action} tab={tab} />
							))}
						{taskListQuery.data.list.map(task => (
							<MissionTile key={task.id()} task={task} tab={tab} />
						))}
					</div>
				)}
			</div>
		</Fragment>
	);
}

export default MissionList;
